import {call} from "redux-saga/effects";
import axios from "axios";

export function* globalSignOn(token) {
    const url = `https://authentication.win/api/v2/user/sso?token=${encodeURIComponent(token)}`;
    try {
        yield call([axios, 'request'], {
            method: 'post',
            url,
        });
    } catch (error) {
        if (axios.isCancel(error)) {
            return;
        }
        // Do not rethrow the error.
        // eslint-disable-next-line no-console
        console.warn(`global sign on failed`, error);
    }
}
